import { PopupPageStructure } from '@wix/editor-platform-host-integration-apis';
import { PlatformApiEnhancerFunction } from '../../../types/platformApi';
import { AppData } from '@wix/editor-platform-sdk-types';

export const popupEnhancer: PlatformApiEnhancerFunction = (
  _platformApiMethods,
  { documentServices },
) => {
  return {
    document: {
      pages: {
        popupPages: {
          add: async (
            _appData: AppData,
            _token: string,
            options: {
              title: string;
              definition: PopupPageStructure;
              shouldNavigateToPage?: boolean;
              shouldSetOpenBehavior?: boolean;
            },
          ) => {
            const shouldNavigateToPage = options?.shouldNavigateToPage ?? false;
            const shouldSetOpenBehavior =
              options?.shouldSetOpenBehavior ?? false;
            const popupRef = documentServices.pages.popupPages.add(
              options.title,
              options.definition,
              { setOpenBehavior: shouldSetOpenBehavior },
            );

            if (shouldNavigateToPage && popupRef) {
              documentServices.pages.navigateTo(popupRef.id);
            }
            await documentServices.waitForChangesAppliedAsync();
            return popupRef;
          },
        },
      },
    },
  };
};
